// Check if current URL contains specific modes where refresh should be hidden
export const shouldHideRefresh = () => {
  const currentPath = window.location.pathname + window.location.search;
  return (
    currentPath.includes('/present-view') ||
    currentPath.includes('/search-mode') ||
    currentPath.includes('/docFinder') ||
    currentPath.includes('/all-annotations')
  );
};

// Check if AI icon should be shown
export const shouldShowAIIcon = () => {
  const currentPath = window.location.pathname + window.location.search;
  return (
    currentPath.includes('/trialbundles/') ||
    currentPath.includes('/teamBundles/') ||
    currentPath.includes('/privateBundles/')
  );
};

// Check if current page is search mode page
export const isSearchModePage = (category?: string) => {
  const currentPath = window.location.pathname + window.location.search;
  return currentPath.includes('/search-mode') || category === 'Search Mode';
};

// Check if add filter button should be shown
export const shouldShowAddFilterButton = () => {
  const currentPath = window.location.pathname;

  // Pattern: /case/{caseId}/...
  // Format type 1: Bundle paths (trialbundles, teamBundles, privateBundles)
  const bundlePathRegex = /^\/case\/[^/]+\/(trialbundles|teamBundles|privateBundles)\//;
  const isBundlePath = bundlePathRegex.test(currentPath);

  // Format type 2: Static paths (all-documents, present-view, search-mode, docFinder)
  const staticPathRegex =
    /^\/case\/[^/]+\/(all-documents|recycle-bin|present-view|search-mode|docFinder)(\/|$)/;
  const isStaticPath = staticPathRegex.test(currentPath);

  return isBundlePath || isStaticPath;
};

// Check path for custom containers
export const checkPathForCustomContainers = (val: any, containers: any) => {
  if (containers) {
    const translations = ['case.trialbooks', 'case.courtBundles', 'case.bundles'];
    if (val === translations[0]) return containers[0];
    else if (val === translations[1]) return containers[1];
    else if (val === translations[2]) return containers[2];
    else return val;
  } else return val;
};
